import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type FeedbackDTO = {
  id: string;
  studentId: string;
  videoId: string;
  message: string;
  student: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  video: {
    name: string;
  };
};

type FeedbackResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: FeedbackDTO[];
};
export const GetFeedbacks = async (): Promise<FeedbackResponse> => {
  try {
    const response = await axios.get(`/feedback-video/all`);
    
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
